import { Injectable } from "@angular/core";
import {
  HttpInterceptor,
  HttpEvent,
  HttpHandler,
  HttpRequest,
  HttpErrorResponse,
} from "@angular/common/http";
import { catchError, finalize, Observable, switchMap, throwError } from "rxjs";
import { AuthService } from "../common/auth.service";
import { LoadingService } from "../common/loading.service";
import { CommonService } from "../common/common.service";
import { LoginService } from "../login/login.service";
import { GlobalConstants } from "src/app/constants/global-constants";
import { ServiceUrlConstants } from "src/app/constants/service-url-constants";

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(
    private authService: AuthService,
    private loadingService: LoadingService,
    private cs: CommonService,
    private loginService: LoginService
  ) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    this.loadingService.show();
    return next.handle(request).pipe(
      finalize(() => {
        this.loadingService.hide();
      }),
      catchError((error) => {
        if (error.error?.message=='Token may have expired. Please renew your session.' && error.status==401
        ) {
          return this.handleTokenRefresh(request, next);
        } else {
          const isRefreshCall = request.url.includes(ServiceUrlConstants.API_SESSION_REFRESH);
          if (
            error instanceof HttpErrorResponse &&
            error.status === 401 &&
            (request.headers.has('Authorization') || isRefreshCall)
          ) {
            this.cs.routeTo(GlobalConstants.ROUTING.LOGIN);
            this.authService.logout();
          }
          return throwError(() => JSON.stringify(error));
        }
      })
    );
  }

  private handleTokenRefresh(request: HttpRequest<any>, next: HttpHandler) {
    return this.loginService.refreshToken().pipe(
      switchMap((refreshTokenResponse: any) => {
        AuthService.setToken(refreshTokenResponse.token);
        AuthService.setRefreshToken(refreshTokenResponse.refreshToken);
        return next.handle(
          request.clone({
            setHeaders: {
              Authorization: `Bearer ${refreshTokenResponse.token}`,
            },
          })
        );
      })
    );
  }
}
